import React from "react";
import { Form, Button } from "semantic-ui-react";
import { useFormik } from "formik";
import { UserPartner } from "../../../../../api";
import { useAuth } from "../../../../../hooks";
import {
  initialValuesThree,
  validationSchemaTrhee,
} from "./PartnerFormThree.form";
import { toast, ToastContainer } from "react-toastify";

const partnerUserCntroller = new UserPartner();

export function PartnerFormThree(props) {
  const { formData, prevStep, user, onReload, onClose } = props;
  const { accessToken } = useAuth();
  const formik = useFormik({
    initialValues: initialValuesThree(user.user, formData),
    validationSchema: validationSchemaTrhee(),
    validateOnChange: false,
    onSubmit: async (values) => {
      try {
        const finalData = {
          ...formData,
          ...values, // Este es el último formulario, pero ya tenemos los datos acumulados
        };

        await partnerUserCntroller.createUser(
          accessToken,
          finalData,
          user.user,
        );
        console.log("finalData", finalData, "  user.user._id", user.user);
        onReload();
        onClose();
      } catch (error) {
        toast.error(`Error: ${error.message}`, {
          position: "top-center",
          autoClose: false, // Para que el usuario tenga que cerrarlo manualmente
          closeOnClick: true,
        });
      }
    },
  });

  return (
    <>
      <ToastContainer />
      <Form onSubmit={formik.handleSubmit}>
        <Form.Input
          type="text"
          name="contactPersons[0].name"
          placeholder="Nombre"
          onChange={formik.handleChange}
          value={formik.values.contactPersons[0].name}
          error={
            formik.errors.contactPersons?.[0]?.name
              ? {
                  content: formik.errors.contactPersons[0].name,
                  pointing: "above",
                }
              : null
          }
        />
        <Form.Input
          type="text"
          name="contactPersons[0].phone"
          placeholder="Teléfono"
          onChange={formik.handleChange}
          value={formik.values.contactPersons[0].phone}
          error={
            formik.errors.contactPersons?.[0]?.phone
              ? {
                  content: formik.errors.contactPersons[0].phone,
                  pointing: "above",
                }
              : null
          }
        />
        <Form.Input
          type="email"
          name="contactPersons[0].email"
          placeholder="Email"
          onChange={formik.handleChange}
          value={formik.values.contactPersons[0].email}
          error={
            formik.errors.contactPersons?.[0]?.email
              ? {
                  content: formik.errors.contactPersons[0].email,
                  pointing: "above",
                }
              : null
          }
        />

        <div className="formgroup">
          <Form.Group>
            <Button
              type="button"
              onClick={prevStep}
              color="orange"
              style={{ width: "33.3333%" }}
            >
              Anterior
            </Button>
            <Button
              type="submit"
              primary
              style={{
                width: "33.3333%",
              }}
              loading={formik.isSubmitting}
            >
              Registrar
            </Button>
          </Form.Group>
        </div>
      </Form>
    </>
  );
}
